if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.lists = [];
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;
            this.isSingleList = !swat.retailerSettings.Wishlist.EnableCollections;
            this.isShareEnabledUsingSocialMedia = swat.retailerSettings.Wishlist.AllowSharing;
            this.isSFLEnabled = swat.retailerSettings.SFL.SFLFeatureEnabled;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.listSenderName = this.querySelector('#swymcs-lists-share-sender-details-name-value'); 
            this.listSenderEmail = this.querySelector('#swymcs-lists-share-sender-details-email-value');
            this.listSenderTier = this.querySelector('#swymcs-lists-share-sender-details-tier-value');
            this.pageTitleTabContainer = this.querySelector('#swymcs-title-wrapper');
            this.pageTitleWishlistTab = this.querySelector('#swymcs-page-title');
            this.pageTitleSFLTab = this.querySelector('#swymcs-sfl-page-title');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.emptySFLListContainer = this.querySelector('#swym-empty-sfl-list-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');
            this.pageLoader = this.querySelector("#swymcs-loader-container");

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');
            this.exportAsCSVButton = this.querySelector('#swymcs-export-as-csv');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
                this.additionalShareButtonsContainer = this.querySelector('.swymcs-additional-share-buttons-container');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 

                this.noteTimers = new WeakMap();
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.pageTitleTabContainer.addEventListener('click', this._toggleListView.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));
            this.exportAsCSVButton.addEventListener('click', this._handleExportAsCSV.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            if(!this.isShareWishlistPage) this.productsContainer.addEventListener('input', this._updateProductNote.bind(this));
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));
        }

        async _triggerBackToListView(){
            this._renderMultipleList();
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                const shareButton = target.closest('.swymcs-list-share-button');
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                if (shareButton && shareButton.dataset.action === 'share') {
                    window.currentActiveListId = lid;
                    page._renderShareListPopup(evt);
                }
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getCompleteListDetails();
            this.lists.length ? (this.isSingleList ? this._renderSingleList() : this._renderMultipleList()) : this._renderEmptyState();
            this._renderSFLContents()
        }

        async _renderShareWishlist(){
            const lid = new URL(document.location).searchParams.get("lid");
            
            // Common UI updates
            const updateUI = (showHeader = true) => {
                this._showContainer(this.listProductsContainer);
                this._showContainer(this.wishlistContainer);
                this._hideContainer(this.pageLoader);
                this._hideContainer(this.backToListView);
                if (!showHeader) {
                    this._hideContainer(this.wishlistHeader);
                }
            };

            if(!lid){
                this._renderProductsGrid([]);
                updateUI(false);
                return;
            }

            window.currentActiveListId = lid;
            try {
                const wishlistProducts = await this._getProductsFromList(lid);
                this.listcontents = await this._getShopifyProductsData(wishlistProducts);
                if(!this.listcontents || !this.listcontents.length){
                    this._renderEmptyList();
                    updateUI(false);
                    return;
                }
                
                await this._renderSharedListHeader(lid);
                this._renderProductsGrid(this.listcontents);
                if(window.isLoggedIn && window.isStoreOwner ) this._showCopyLinkInput();
                updateUI();
            } catch (error) {
                console.error('Error fetching wishlist products:', error);
                this._renderEmptyList();
                updateUI(false);
            }
        }

        async _renderSingleList() {
            if (this.list && this.list.listcontents) {
                this._hideContainer(this.pageLoader);
                this._showContainer(this.wishlistHeader);
                this._renderProductsGrid(this.list.listcontents);
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }

            this.lists = await this._getLists();
            if (!this.lists.length) {
                this._renderEmptyState();
                return;
            }
            this.list = this.lists.find(list => list.lname.toLowerCase() == 'my wishlist') || this.lists[0];
            window.currentActiveListId = this.list.lid;
            this.list.listcontents = await this._getProductsFromList(this.list.lid);
            this.list.listcontents = await this._getShopifyProductsData(this.list.listcontents);

            // Cache the list data
            this.list = this._setListProperties(this.list, this.list.listcontents, true);

            this._hideContainer(this.pageLoader);
            await this._renderSingleListHeader(this.list.lid);
            this._renderProductsGrid(this.list.listcontents);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderMultipleList() {
            if(!this.lists.length){
                this._renderEmptyState();
                return;
            }
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this._hideContainer(this.pageLoader);
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            const html = this.lists.map(list => {
                const productCount = list.totalProducts || 0;
                const buttonText = !productCount ? 'Continue Shopping' : 'View List';
                const buttonAction = !productCount ? 'shop' : 'view-list';
                
                const imageHtml = this._generateListPreviewImages(list);
                
                return `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" 
                            data-lid="${list.lid}" 
                            aria-label="View list ${list.lname}" 
                            id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                            <div class="swymcs-list-share-button" data-lid="${list.lid}" data-action="share"><svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M5 7c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm11.122 12.065c-.073.301-.122.611-.122.935 0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4c-1.165 0-2.204.506-2.935 1.301l-5.488-2.927c-.23.636-.549 1.229-.943 1.764l5.488 2.927zm7.878-15.065c0-2.209-1.791-4-4-4s-4 1.791-4 4c0 .324.049.634.122.935l-5.488 2.927c.395.535.713 1.127.943 1.764l5.488-2.927c.731.795 1.77 1.301 2.935 1.301 2.209 0 4-1.791 4-4z"></path></svg></div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${productCount}</span>
                            <span class="swymcs-product-count-text">${productCount > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" 
                             data-action="${buttonAction}" 
                             id="swymcs-view-list-button-${list.lid}" 
                             aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            }).join('');

            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._hideContainer(this.pageLoader);
            this._scrollToTop();
        }

        _generateListPreviewImages(list) {
            const listContents = list?.listcontents || [];
            let imageHtml = `<div class="swymcs-list-image-container">`;
            
            if(listContents.length) {
                for(let i = 0; i < 3; i++) {
                    if(listContents[i]) {
                        const product = listContents[i].productData;
                        const selectedVariant = product.variants.find(variant => variant.id === listContents[i].epi);
                        const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  listContents[i].iu;
                        imageHtml += `
                            <div class="swymcs-wishlist-image-wrapper">
                                <img src="${imageSrc}" 
                                     alt="${listContents[i].productData.title}" 
                                     class="swymcs-wishlist-image"/>
                            </div>`;
                    }
                }
                imageHtml += '</div>';
            } else {
                imageHtml += `<p class="swymcs-no-products-message">This is an empty list!</p></div>`;
            }
            
            return imageHtml;
        }

        async _renderListProducts(lid){
            this._hideContainer(this.listsContainer);
            this._showContainer(this.pageLoader);
            this._showContainer(this.wishlistHeader);
            this._showContainer(this.backToListView);
            this._showContainer(this.activeListContainer);
            window.currentActiveListId = lid;
            
            const selectedList = this.lists.find(list => list.lid == lid);
            if(!selectedList.allProductsLoaded) {
                // Load all products only when viewing full list
                const allProducts = await this._getProductsFromList(lid);
                selectedList.listcontents = await this._getShopifyProductsData(allProducts);
                selectedList.allProductsLoaded = true;
            }
            this.selectedListContents = selectedList.listcontents;
            console.log('selectedListContents', this.selectedListContents);
            
            this._renderListHeader(lid);
            this._hideContainer(this.pageLoader);
            this._renderProductsGrid(selectedList.listcontents);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(lid){
            const { list: activeList } = await this._getListDetails(lid);
            activeList.listcontents = this.listcontents;
            this.lname = activeList.lname;
            this._renderActiveList(activeList);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
        }

        async _renderSingleListHeader(lid){
            this._renderActiveList(this.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._showContainer(this.additionalOptionsBtn);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.pageLoader);
            this._hideContainer(this.renameListButton);
            this._hideContainer(this.duplicateListButton);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    const product = listContents[0].productData;
                    const selectedVariant = product.variants.find(variant => variant.id === listContents[0].epi);
                    const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image || listContents[0].iu;
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${imageSrc}" alt="${list.lname}"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const listContent = list?.listcontents || [];
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts, type = 'wishlist'){
            if(!shopifyProducts.length) {
                if(type == 'sfl') this._renderEmptySFLList();
                else this._renderEmptyList();
                this._hideContainer(this.exportAsCSVButton);
                return;
            }
            this._showContainer(this.exportAsCSVButton);
            let productMarkup = `
                <li id="wishlist-grid-item--header"  class="grid__item swymcs-product-card">
                    <div class="card-wrapper swymcs-list-product product-card-wrapper underline-links-hover" bis_skin_checked="1">
                        <div class="card card--standard card--media" style="--ratio-percent: 100%;" bis_skin_checked="1">
                            <div class="card__header__image">Item</div>
                            <div class="card__header__item">Item Name</div>
                            <div class="card__header__price">Price</div>
                            <div class="card__header__qty">Qty</div>
                            <div class="card__header__total">Total</div>
                            <div class="card__header__note">Notes</div>
                        </div>
                    </div>
                </li>
            `;
            shopifyProducts.forEach(async (pdp, index) => {
                if(!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const totalPrice = parseFloat((selectedVariantPrice * (pdp.qty ?? 1))/100.00).toFixed(2);
                const selectedVariantCompareAtPrice = selectedVariant.compare_at_price > 0 && selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : 0;
                const labelText = product.metafieldData != 'NA' ? product.metafieldData : '';
                let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const productUrl = pdp?.product?.du || pdp.du;

                const variantOptionPairs = [];
                if (selectedVariant.sku) {
                    variantOptionPairs.push(`<span class="swymcs-variant-title">SKU : </span><span class="swymcs-variant-value">${selectedVariant.sku}</span>`);
                }
                const otherOptions = product.options
                    .filter(option => option.name !== "Title")
                    .map(option => `<span class="swymcs-variant-title">${option.name} : </span><span class="swymcs-variant-value">${selectedVariant[`option${option.position}`]}</span>`);
                variantOptionPairs.push(...otherOptions);
                let variantsHTML = `<div class="caption-with-letter-spacing light" bis_skin_checked="1">${variantOptionPairs.join(' | ')}</div>`;

                productMarkup += `
                    <li id="wishlist-grid-item--${index}"  data-url="${productUrl}" data-lid="${lid}" data-epi="${selectedVariant.id}" class="grid__item swymcs-product-card">
                        <div class="card-wrapper swymcs-list-product product-card-wrapper underline-links-hover" bis_skin_checked="1">
                            <div class="card card--standard card--media" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                    <div class="card__media" bis_skin_checked="1">
                                        <div class="media media--transparent media--hover-effect" bis_skin_checked="1">
                                            <img src="${imageSrc}" alt="${product.title}" class="motion-reduce" loading="lazy"/> 
                                        </div>
                                    </div>
                                </div>
                                <div class="card__content" bis_skin_checked="1">
                                    <div class="card__information" bis_skin_checked="1">
                                        <h3 class="card__heading h5">
                                            <a href="${productUrl}" class="full-unstyled-link" aria-label="Visit ${product.title} page">${product.title}</a>
                                        </h3>
                                        <div class="card-information" bis_skin_checked="1">
                                            ${variantsHTML}
                                        </div>
                                    </div>
                                </div>
                                <div class="card__price">
                                    <div class="price " bis_skin_checked="1">
                                        <div class="price__container" bis_skin_checked="1">
                                            <div class="price__regular" bis_skin_checked="1">
                                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span class="price-item price-item--regular">
                                                    ${window.currencyCode}${selectedVariantPrice}
                                                </span>
                                            </div>
                                            ${selectedVariantCompareAtPrice > 0 ? `
                                                <div class="price__sale" bis_skin_checked="1">
                                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span>
                                                    <s class="price-item price-item--regular"></s>
                                                </span>
                                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                <span class="price-item price-item--sale price-item--last">
                                                    ${window.currencyCode}${selectedVariantCompareAtPrice}
                                                </span>
                                                </div>` : ``
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div class="swymcs-product-qty">
                                    <div class="quantity-selector">
                                        <button class="minus-button" data-purpose="updateQuantity" data-product-url="${pdp.du}" data-variant-id="${selectedVariant.id}" data-product-id="${product.id}" ${this.isShareWishlistPage ? 'disabled' : ''} data-price="${selectedVariant.price}" ${pdp.qty == 1 || !pdp.qty ? 'disabled' : ''} >-</button>
                                        <input type="number" min="1" id="swymCustomQuantityInput" disabled="" class="quantity-input" value="${pdp.qty ?? 1}" data-product-url="${pdp.du}" data-variant-id="${selectedVariant.id}" data-product-id="${product.id}">
                                        <button class="plus-button" data-purpose="updateQuantity" data-product-url="${pdp.du}" data-variant-id="${selectedVariant.id}" data-product-id="${product.id}" ${this.isShareWishlistPage ? 'disabled' : ''} data-price="${selectedVariant.price}">+</button>
                                    </div>
                                </div>
                                <div class="swymcs-product-total">
                                    <div class="swymcs-product-total-text">${window.currencyCode}${totalPrice}</div>
                                </div>
                                <div class="swymcs-product-note">
                                    <div class="swymcs-product-note-container">
                                        <textarea class="swymcs-product-note-input" placeholder="${!this.isShareWishlistPage ? 'Notes' : ''}" data-purpose="note" data-product-url="${pdp.du}" data-variant-id="${selectedVariant.id}" data-product-id="${product.id}" ${this.isShareWishlistPage ? 'disabled' : ''}>${pdp.note ?? ''}</textarea>
                                        <div class="swymcs-note-status ${this.isShareWishlistPage ? 'swym-hide-container' : ''}">Saved</div>
                                    </div>
                                </div>
                                <div class="swymcs-product-buttons">
                                    <button ${isButtonDisabled} data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" 
                                        class="${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}">
                                        ${addToCartBtnText}
                                    </button>
                                </div>
                                <div class="swymcs-product-delete">
                                    <button data-list-type="${type}" data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="swymcs-button swymcs-product-delete-btn ${this.isShareWishlistPage && 'swym-hide-container'}" aria-label="Delete ${product.title}">
                                        <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
        }

        _renderEmptySFLList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptySFLListContent;
            this.productsContainer.querySelector('#swym-empty-sfl-list-container').classList.remove('swym-hide-container');
        }

        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if(!window.isLoggedIn) {
                this._hidePopupContainer(this.additionalOptionsContainer);
                this._showPopupContainer(this.accountPopup);
                return;
            }

            const list = this.lists.find(list => list.lid == window.currentActiveListId);
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            
            !this.isShareEnabledUsingSocialMedia && this._hideContainer(this.additionalShareButtonsContainer);
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
            await this._markListAsPublic();
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        async _getCompleteListDetails(){
            const lists = await this._getLists();
            if(!lists.length) return lists;
            
            // Load only first 3 products for each list for preview
            await Promise.all(lists.map(async list => {
                const products = await this._getProductsFromList(list.lid);
                list.listcontents = products.slice(0, 3); // Only get first 3 products for preview
                list.listcontents = await this._getShopifyProductsData(list.listcontents);
                if(products.length <= 3) list.allProductsLoaded = true;
                list.totalProducts = products.length; // Store total count
            }));
            return lists;
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }
      
       async _getShopifyProductsData(products){
            if(!products.length) return []; 
            const section = this;   
            let buggedProductsArray = []; 
            let res = await Promise.all(products.map(async (pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    pdp.productData = jsonData;
                    return pdp;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[pdp.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));

            console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _setListProperties(list, listContents, allProductsLoaded = false) {
            list.listcontents = listContents;
            list.totalProducts = listContents.length;
            list.allProductsLoaded = allProductsLoaded;
            return list;
        }

        _updateProductQuantity(evt){
            const quantitySelector = evt.target.closest('.quantity-selector');
            const input = quantitySelector.querySelector('input');
            const currentQty = parseInt(input.value);
            const isIncrease = evt.target.classList.contains('plus-button');
            const newQty = isIncrease ? currentQty + 1 : currentQty - 1;
            const price = evt.target.dataset.price;
            const total = evt.target.closest('li.swymcs-product-card').querySelector('.swymcs-product-total-text');
            
            const productData = {
                epi: evt.target.dataset.variantId,
                empi: evt.target.dataset.productId,
                du: evt.target.dataset.productUrl,
                qty: newQty
            };
            
            const onSuccess = updatedListItem => {
                input.value = newQty;
                total.textContent = window.currencyCode + parseFloat((newQty * price)/100.00).toFixed(2);
                if (newQty === 1) {
                    quantitySelector.querySelector('.minus-button').disabled = true;
                } else {
                    quantitySelector.querySelector('.minus-button').disabled = false;
                }
                this._updateProductLocally(productData, 'qty', newQty);
            };
            const onError = error => console.log("Error while updating the List Item", error);
            this.swat.updateListItem(window.currentActiveListId, productData, onSuccess, onError);
        }

        _deleteProductFromList(product, lid, parentNode, listType){
            const onSuccessWishlist = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card:not(#wishlist-grid-item--header)')){
                    this._renderProductsGrid([]);
                }
                if(this.isSingleList) {
                    this.list.listcontents = this.list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                    this.list = this._setListProperties(this.list, this.list.listcontents, true);
                    this._renderSingleListHeader(lid);
                } else {
                    this.lists = this.lists.map(list => {
                        if (list.lid === lid) {
                            const updatedListContents = list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                            return this._setListProperties({...list}, updatedListContents, true);
                        }
                        return list;
                    });
                    this._renderListHeader(lid); 
                }
            }

            const onSuccessSFL = async response => {
                const deletedProduct = response.itemsdeleted[0];
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([], 'sfl');
                }
                this.sflList.listcontents = this.sflList.listcontents.filter(product => product.epi !== deletedProduct.epi);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            if(listType == 'wishlist') this.swat.deleteFromList(lid, product, onSuccessWishlist, onError);
            else if(listType == 'sfl') this.swat.SaveForLater.remove(lid, [product], onSuccessSFL, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                const listcontents = this.lists.find(list => list.lid === updatedListObj.lid).listcontents;
                this.lists = this.lists.map(list => list.lid === updatedListObj.lid ? this._setListProperties(updatedListObj, listcontents, true) : list);
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                const listContents = this.lists.find(list => list.lid === window.currentActiveListId).listcontents;
                this.lists.unshift(this._setListProperties(listObj, listContents, true));
                this._hideContainer(this.listProductsContainer);
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this.lists = this.lists.filter(list => list.lid != window.currentActiveListId);
                this._hideContainer(this.listProductsContainer);
                this._showContainer(this.pageLoader);
                if(this.isSingleList) {
                    this.list = null;
                }
                this.isSingleList ? this._renderSingleList() : this._renderMultipleList();
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to cart'; 
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            }, (error) => {
                button.textContent = 'Add to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        async _addAllProductToCart(evt) {
            const page = this;
            try {
                const productsData = [...page.querySelectorAll('.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)')].map(container => ({
                    id: +container.dataset.epi,
                    quantity: 1
                }));
                let formData = { 'items': productsData };
        
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
        
                const cartResponse = await response.json();
                cartResponse.items.forEach(item => {
                    const variantId = item.id;
                    const button = page.querySelector(`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`);
                    button.textContent = 'Added to cart';
                });
                evt.target.textContent = 'Added to cart';
                this._scrollToTop();
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            } catch (error) {
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error:', error);
            }
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        async _renderSFLContents(){
            if(!this.isSFLEnabled || this.isShareWishlistPage) return;
            this.sflList = await this._getSflList();
            window.saveForLaterListId = this.sflList.listid;
            const sflProducts = await this._getSflProducts();
            this.sflList.listcontents = await this._getShopifyProductsData(sflProducts);
            this._showContainer(this.pageTitleSFLTab);
        }

        _getSflList() {
            return new Promise(async (resolve, reject) => {
                this.swat.SaveForLater.init(
                    (list) => resolve(list),
                    (error) => reject(error)
                );
            });
        }

        async _getSflProducts(){
            return new Promise(async (resolve, reject) => {
                this.swat.SaveForLater.fetch(
                  window.saveForLaterListId,
                  (products) => resolve(products.items),
                  (error) => reject(error)
                );
            });
        }

        async _renderSFLContainer(){
            this._hideContainer(this.listsContainer);
            this._hideContainer(this.wishlistHeader);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.emptyListContainer);
            this._hideContainer(this.emptySFLListContainer);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            this._renderProductsGrid(this.sflList.listcontents, "sfl");
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            page._hideContainer(page.listProductsContainer);
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        _toggleListView(evt){
            if(!this.isSFLEnabled || this.isShareWishlistPage) return;
            const target = evt.target;
            if(target.classList.contains('swymcs-active-tab') && !target.classList.contains('swymcs-page-title')) return;
            this.pageTitleTabContainer.querySelectorAll('.swymcs-page-title').forEach(tab => tab.classList.remove('swymcs-active-tab'));
            target.classList.add('swymcs-active-tab');
            if(target.dataset.type == 'wishlist'){
                this.isSingleList ? this._renderSingleList() : this._renderMultipleList();
            } 
            else if(target.dataset.type == 'sfl') this._renderSFLContainer();
        }

        /* Product Grid Events */
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return; 
            evt.preventDefault();
            if(purpose == 'cart') page._addProductToCart(target);
            else if(purpose == 'select') page._selectProductSize(target);
            else if (purpose == 'updateQuantity') page._updateProductQuantity(evt);
            else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card'), target.dataset.listType
                );
            }
        }

        _updateProductLocally(product,attribute,value){
            const list = this.lists.find(list => list.lid === window.currentActiveListId);
            const updatedProduct = list.listcontents.find(p => p.epi == product.epi && p.empi == product.empi);
            if(updatedProduct){
                updatedProduct[attribute] = value;
            }
        }

        _updateProductNote(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return; 
            evt.preventDefault();
            if (purpose == 'note') page._handleNoteChange(target);
        }

        _handleNoteChange(textarea) {
            const note = textarea.value;
            const status = textarea.closest('.swymcs-product-note-container').querySelector('.swymcs-note-status');
            status.textContent = 'Unsaved';
            textarea.classList.remove('swymcs-saved');
            textarea.classList.add('swymcs-unsaved');
            clearTimeout(this.noteTimers.get(textarea));
            const timeout = setTimeout(() => {
                status.innerHTML = '<svg width="40px" height="40px" enable-background="new 0 0 0 0" version="1.1" viewBox="0 0 100 100" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="50" r="6"><animate attributeName="opacity" begin="0.1" dur="1s" repeatCount="indefinite" values="0;1;0"></animate></circle><circle cx="50" cy="50" r="6"><animate attributeName="opacity" begin="0.2" dur="1s" repeatCount="indefinite" values="0;1;0"></animate></circle><circle cx="80" cy="50" r="6"><animate attributeName="opacity" begin="0.3" dur="1s" repeatCount="indefinite" values="0;1;0"></animate></circle></svg>';
                const lid = window.currentActiveListId;
                const product = {
                    epi: textarea.dataset.variantId,
                    empi: textarea.dataset.productId,
                    du: textarea.dataset.productUrl,
                    note: note,
                };
                const onSuccess = (updatedListItem) => {
                    this._updateProductLocally(product, 'note', note);
                    const currentNote = textarea.value;
                    if (currentNote === note) {
                        status.textContent = 'Saved';
                        textarea.classList.remove('swymcs-unsaved');
                        textarea.classList.add('swymcs-saved');
                    }
                };                  
                const onError = function(error) {
                    console.error("❌ Error while updating the List Item", error);
                };
                this.swat.updateListItem(lid, product, onSuccess, onError);
            }, 1500);
            this.noteTimers.set(textarea, timeout);
        }

        _selectProductSize(sizeButton){
            const selectedVariantClass = 'swym-selected-variant';
            const parentNode = sizeButton.closest('.swymcs-product-card');
            // If selected variant is clicked - DO NOTHING
            if(sizeButton.classList.contains(selectedVariantClass)) return; 

            // Switch selected variants
            parentNode.querySelector(`.${selectedVariantClass}.swymcs-variant-selector-btn`).classList.remove(selectedVariantClass);
            sizeButton.classList.add(selectedVariantClass);

            const addToCartButton = parentNode.querySelector('.swymcs-add-to-cart-btn');
            const isVariantAvailable = sizeButton.dataset.available == 'true';
            const variantId = sizeButton.dataset.variantId;
            const variantCost = sizeButton.dataset.variantCost;
            const priceContainer = parentNode.querySelector('.price-item.price-item--regular');

            // Perform proper logical functions
            isVariantAvailable ? addToCartButton.removeAttribute('disabled') : addToCartButton.setAttribute('disabled', '');
            addToCartButton.classList.toggle('swymcs-sold-out', !isVariantAvailable);
            let addToCartBtnText = this.settings.sold_out_text;
            if(isVariantAvailable) {
                addToCartBtnText = this.swat.platform.isInDeviceCart(variantId) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`;
            }
            addToCartButton.setAttribute('data-epi', variantId);
            addToCartButton.setAttribute('data-variant-cost', variantCost);
            addToCartButton.textContent = addToCartBtnText;
            priceContainer.textContent = `${window.currencyCode}${variantCost}`;
        }

        /* Additional Options */
        _handleExportAsCSV(event){
            const data = this.isShareWishlistPage ? this.listcontents : this.lists.find(list => list.lid === window.currentActiveListId).listcontents;
            const categoryName = this.isShareWishlistPage ? this.lname : this.lists.find(list => list.lid === window.currentActiveListId).lname;
            const fileName = categoryName.replace(/\s+/g, '_') + '.csv';
            
            const transformedData = data.map((item, index) => {
                const product = item.productData;
                const selectedVariant = product.variants.find(variant => variant.id === item.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const productUrl = item?.product?.du || item.du;
                const sku = selectedVariant?.sku || '';
    
                const newItem = {
                    'S.No': index + 1,
                    'Product Title': product.title,
                    'Variant Title': selectedVariantTitle,
                    'Product URL': productUrl,
                    //'Product Price': '$' + selectedVariantPrice,
                    'Product Quantity': item.qty ?? 1,
                    'Product Note': item.note ?? '',
                    'Product SKU': sku
                };
                return newItem;
            });
    
            const headers = Object.keys(transformedData[0]);
            const csvRows = [headers.join(',')];
    
            transformedData.forEach((item) => {
                const row = headers.map(header => item[header]).join(',');
                csvRows.push(row);
            });
    
            const csvContent = csvRows.join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            link.remove();
        }
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}